export const NOOP = () => {};

export const NOOPTRUE = () => true;
